import * as ActionTypes from './actionTypes'

export const metaUpdated = () => ({ type: ActionTypes.surveyMetaUpdated })
